/**
 * Http请求包装对象
 * 参考： iview https://gitee.com/icarusion/iview-admin/blob/master/src/libs/axios.js
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */
import axios from 'axios'
import storage from '@/utils/jeepayStorageWrapper'
import appConfig from '@/config/appConfig'
import Vue from 'vue'
import store from '@/store/index'
import router from '@/router'
import {getToken} from "@/utils/auth";
class HttpRequest {
  constructor (baseUrl = process.env.VUE_APP_API_BASE_URL) {
    this.baseUrl = baseUrl
    this.queue = {} // 发送队列, 格式为: {请求url: true}, 可以做一些验证之类
  }
  // 基础配置信息
  baseConfig () {
    const headers = {}
    headers['Authorization'] = localStorage.getItem("setToken")
    headers[appConfig.ACCESS_TOKEN_NAME] = storage.getToken()
    return {
      baseURL: this.baseUrl,
      headers: headers
    }
  }
  destroy (url, showLoading) {
    delete this.queue[url]
  }
  interceptors (instance, url, showErrorMsg, showLoading) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length && showLoading) {
        store.commit('showLoading') // 加载中显示loading组件
      }
      this.queue[url] = true
      return config
    }, error => {
      store.commit('hideLoading') // 报错关闭loading组件
      return Promise.reject(error)
    })

    // 响应拦截
    instance.interceptors.response.use(res => {
      // console.log(res,'res+++++++111111111')
      if(res.headers['content-type'] == "application/x-download" ){
        const resData = res
        return resData
      }
      if( res.data.type == "text/html" || res.data.type == "application/x-msdownload"){
        const resData = res.data
        return resData
      }

      this.destroy(url, showLoading)
      if (showLoading) {
        store.commit('hideLoading') // 报错关闭loading组件
      }
      const resData = res.data // 接口实际返回数据 格式为：{code: '', msg: '', data: ''}， res.data 是axios封装对象的返回数据；
      if (resData.code === 401) { // 无访问权限，会话超时， 提示用户信息 & 退出系统
        Vue.prototype.$message.error('登录状态超时，请重新登录!');
        localStorage.removeItem("setToken");
        localStorage.removeItem("companyinfo");
        router.push('/')
        return resData;
      }
      if (resData.code != 200 && resData.code != 0) {
        Vue.prototype.$message.error(resData.msg || resData.message);
      }
      if (resData.code !== 200 && resData.code != 0) { // 相应结果不为0， 说明异常

        if (resData.code !== 200 && resData.code != 0 && resData.code == 401) {
          Vue.prototype.$message.error(resData.msg || resData.message);
        }

        if (showErrorMsg) {
          Vue.prototype.$message.error(resData.msg || resData.message) // 显示异常信息

        }
        return Promise.reject(resData)
      } else {
        return resData
      }

    }, error => {
      this.destroy(url, showLoading)

      if (showLoading) {
        store.commit('hideLoading') // 报错关闭loading组件
      }

      let errorInfo = error.response && error.response.data && error.response.data.data
      if (!errorInfo) {
        errorInfo = error.response ? error.response.data : error.message
      }
      // console.log(error,'error+++++++222222222')
      if (error.response && (error.response.status === 401 || error.response.status === 404)) { // 无访问权限，会话超时， 提示用户信息 & 退出系统
        Vue.prototype.$message.error('登录状态超时，请重新登录!');
        localStorage.removeItem("setToken");
        localStorage.removeItem("companyinfo");
        router.push('/')

      }else {
        if (showErrorMsg) {
          Vue.prototype.$message.error(JSON.stringify(errorInfo)) // 显示异常信息
        }
      }

      return Promise.reject(errorInfo)
    })
  }
  // interceptorsFlag： 是否进行自定义拦截器处理，默认为： true
  // showErrorMsg 发送请求出现异常是否全局提示错误信息
  // showLoading 发送请求前后显示全局loading
  request (options, interceptorsFlag = true, showErrorMsg = true, showLoading = false) {
    const instance = axios.create()
    options = Object.assign(this.baseConfig(), options)
    if (interceptorsFlag) { // 注入 req, respo 拦截器
      this.interceptors(instance, options.url, showErrorMsg, showLoading)
    }

    return instance(options)
  }
}
export default HttpRequest
